/**
 * Return a string with the same value passed but with the given number of decimals
 * @param value number or string containing a number
 * @param decimals how many decimals digits to show
 * @returns formatted number as string
 */
export function formatNumber(value: string|number, decimals: number): string {
    return Number(value).toFixed(decimals);
}